import React from 'react';

import * as types from 'ui/shared/types';

import styles from './Paragraph.module.scss';

export function Paragraph({
  size = 'md',
  tagType = 'p',
  textAlign = 'left',
  children,
  color = '#676767',
  gutterBottom = true,
  transform,
}: types.Paragraph) {
  const ParagraphTag = tagType;

  return (
    <ParagraphTag
      style={{
        textAlign: textAlign,
        color: color,
        textTransform: transform,
        ...(gutterBottom === false && { marginBottom: '0' }),
      }}
      className={`${styles.paragraph} ${styles[`paragraph--${size}`]}`}
    >
      {children}
    </ParagraphTag>
  );
}
